"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginProductsReducer = void 0;
var _actionTypes = require("../actionTypes");
var marginProductsReducer = exports.marginProductsReducer = function marginProductsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    data: [],
    loaded: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _actionTypes.RECEIVE_MARGIN_PRODUCT_CONFIGS:
      return {
        data: action.payload,
        loaded: true
      };
    default:
      return state;
  }
};